export enum AnalyticsProvider {
    Segment = "segment",
    Rudderstack = "rudderstack",
}

export const analyticsProvider: AnalyticsProvider = AnalyticsProvider.Rudderstack;
